import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Annex1Diagnostic from "@/pages/Annex1Diagnostic";

export const Route = createFileRoute("/en/annex-1-diagnostic")({
  head: () => buildRouteHead("/en/annex-1-diagnostic"),
  component: Annex1Diagnostic,
});

